module.exports = __webpack_public_path__ + "img/12_93.6c42e8c2.png";